// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Base Module
// Components
import { Observer } from "mobx-vue";
import H from "@mgs/ci2019-common/src/components/shared/map/heremaps/mapsjs.bundle.js";

@Observer
@Component({
  mixins: [template],
  components: {},
})
export class Map extends Vue {
  @Prop({ default: "350px" })
  public height!: string;

  @Prop({ default: "100%" })
  public width!: string;

  @Prop({ default: () => [] })
  public points!: H.geo.IPoint[];

  @Prop()
  public myLocation!: H.geo.Point;

  @Prop()
  public radius!: number;

  private platform!: H.service.Platform;
  private map!: H.Map;
  private myLocationMarker: H.map.Marker | null = null;
  private radiusCircle: H.map.Circle | null = null;
  private intRadius: number = 1;
  private clusteredDataProvider: any = null;

  private konsiSvg =
    '<svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 34.941 49.607" style="enable-background:new 0 0 34.941 49.607;" xml:space="preserve"> ' +
    '<style type="text/css">' +
    ".st0{fill:#333333;}" +
    ".st1{fill:#FFFFFF;}" +
    "</style>" +
    '<g transform="translate(-5.28 -6)">' +
    '<path class="st0" d="M19.209,40.575C9.763,38.619,3.69,29.375,5.646,19.929S16.846,4.41,26.292,6.366s15.519,11.199,13.563,20.646' +
    'c-1.412,6.821-6.742,12.15-13.563,13.563L22.75,55.607L19.209,40.575z"/>' +
    "</g>" +
    "<g>" +
    '<path class="st1" d="M13.892,20.74c-0.273-0.113-0.579-0.113-0.852,0c-0.129,0.055-0.246,0.133-0.346,0.231' +
    "c-0.101,0.098-0.182,0.214-0.238,0.342c-0.058,0.133-0.087,0.277-0.086,0.422l-0.006,0.002c-0.001,0.145,0.028,0.289,0.086,0.422" +
    "c0.056,0.128,0.137,0.245,0.238,0.342c0.099,0.098,0.217,0.177,0.346,0.231c0.273,0.113,0.579,0.113,0.852,0" +
    "c0.13-0.055,0.247-0.134,0.347-0.234c0.101-0.098,0.182-0.214,0.238-0.342c0.114-0.27,0.114-0.574,0-0.844" +
    'C14.358,21.056,14.151,20.85,13.892,20.74z"/>' +
    '<path class="st1" d="M21.128,17.773l0.707-0.707v-1.454h1.454l0.73-0.73v-1.431h1.431l0.753-0.753V9.131H22.15l-5.715,5.663' +
    "c-0.273-0.084-0.552-0.149-0.834-0.193c-0.285-0.046-0.572-0.068-0.861-0.068c-1.063-0.004-2.108,0.275-3.027,0.809" +
    "c-0.885,0.518-1.626,1.25-2.153,2.13c-1.095,1.847-1.095,4.145,0,5.992c0.262,0.439,0.578,0.844,0.942,1.203" +
    "c0.364,0.361,0.772,0.674,1.215,0.932c0.449,0.26,0.93,0.461,1.431,0.596c1.045,0.281,2.145,0.281,3.19,0" +
    "c0.501-0.135,0.982-0.336,1.431-0.596c0.888-0.518,1.629-1.253,2.156-2.135c0.539-0.906,0.822-1.942,0.819-2.996" +
    "c0-0.94-0.231-1.866-0.674-2.695H21.128z M19.37,18.866c0.186,0.514,0.282,1.056,0.283,1.602c0.004,0.653-0.13,1.3-0.392,1.899" +
    "c-0.249,0.579-0.606,1.105-1.053,1.55c-0.45,0.443-0.979,0.796-1.56,1.042c-1.22,0.51-2.594,0.51-3.815,0" +
    "c-0.581-0.245-1.111-0.599-1.56-1.042c-0.447-0.445-0.804-0.971-1.053-1.55c-0.518-1.207-0.518-2.573,0-3.78" +
    "c0.249-0.579,0.606-1.105,1.053-1.55c0.45-0.443,0.979-0.796,1.56-1.042c0.603-0.256,1.252-0.387,1.907-0.384" +
    "c0.341,0,0.68,0.04,1.011,0.119c0.332,0.08,0.658,0.182,0.976,0.304l5.884-5.819h2.496v2.157h-1.53l-0.653,0.683v1.477h-1.41" +
    'l-0.772,0.809v1.351h-2.183v0.75C18.912,17.865,19.187,18.347,19.37,18.866z"/>' +
    "</g>" +
    "</svg>";

  mounted() {
    this.platform = new H.service.Platform({
      apikey: APP_MAP_API_KEY || "${HERE_MAP_API_KEY}",
      useHTTPS: true,
    });
    var defaultLayers = this.platform.createDefaultLayers();
    defaultLayers.vector.normal.map.setMin(3);

    this.map = new H.Map(
      <Element>this.$refs["mapContainer"],
      defaultLayers.vector.normal.map,
      {
        zoom: 5,
        center: { lat: 51.0, lng: 1.0 },
      }
    );

    window.addEventListener("resize", () => {
      this.map.getViewPort().resize();
    });

    var mapTileService = this.platform.getMapTileService({
      type: "base",
    });

    var mapEvents = new H.mapevents.MapEvents(this.map);
    var behavior = new H.mapevents.Behavior(mapEvents);

    var ui = H.ui.UI.createDefault(this.map, defaultLayers);

    this.startClustering();
  }

  @Watch("myLocation")
  public onMyLocationChange(newVal) {
    if (this.myLocationMarker !== null) {
      this.map.removeObject(this.myLocationMarker);
      this.myLocationMarker = null;
      if (this.radiusCircle !== null) {
        this.map.removeObject(this.radiusCircle);
        this.radiusCircle = null;
      }
    }

    if (newVal !== null && this.map) {
      var svg =
        '<svg class="wb-e-btn-20__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" height="32" width="32"><defs><style>.cls-1{fill:#00adef;}</style></defs><path class="cls-1" d="M32,14.515H29.5A13.559,13.559,0,0,0,17.485,2.492V0h-2.9V2.491A13.6,13.6,0,0,0,2.5,14.515H0v2.9H2.487a13.6,13.6,0,0,0,12.1,12.1V32h2.9V29.5A13.6,13.6,0,0,0,29.513,17.411H32ZM16.037,26.506A10.506,10.506,0,1,1,26.543,16,10.552,10.552,0,0,1,16.037,26.506Z"/><circle class="cls-1" cx="16" cy="16" r="4.9"/></svg>';
      var icon = new H.map.Icon(svg, {
        size: { w: 32, h: 32 },
        anchor: { x: 16, y: 16 },
        crossOrigin: false,
      });
      this.myLocationMarker = new H.map.Marker(newVal, { icon: icon });
      this.map.addObject(this.myLocationMarker);

      var nearest = this.findNearestPoint(newVal);
      if (nearest) {
        this.map.getViewModel().setLookAtData({
          bounds: H.geo.Rect.coverPoints([nearest, newVal]).resizeToCenter(
            newVal
          ),
        });
        this.addCircleToMap(newVal, nearest);
      } else {
        this.map.setCenter({
          lat: newVal.lat,
          lng: newVal.lng,
        });
        this.addCircleToMap(newVal);
      }
    }
  }

  @Watch("radius")
  public onRadiusChange() {
    if (this.radiusCircle) {
      this.radiusCircle.setRadius(this.radius);

      switch (true) {
        case this.radius == 1000 * 1000:
          this.map.setZoom(4);
          break;
        case this.radius == 500 * 1000:
          this.map.setZoom(5);
          break;
        case this.radius >= 200 * 1000 && this.radius < 500 * 1000:
          this.map.setZoom(6);
          break;
        case this.radius == 100 * 1000:
          this.map.setZoom(7);
          break;
        case this.radius >= 50 * 1000 && this.radius < 100 * 1000:
          this.map.setZoom(8);
          break;
        case this.radius == 25 * 1000:
          this.map.setZoom(9);
          break;
        case this.radius >= 15 * 1000 && this.radius <= 20 * 1000:
          this.map.setZoom(10);
          break;
        case this.radius == 10 * 1000:
          this.map.setZoom(11);
          break;
        case this.radius == 5 * 1000:
          this.map.setZoom(12);
          break;
        case this.radius == 2 * 1000:
          this.map.setZoom(13);
          break;
        case this.radius == 1 * 1000:
          this.map.setZoom(14);
          break;
      }
      this.map.setCenter({
        lat: this.myLocation.lat,
        lng: this.myLocation.lng,
      });
    }
  }

  private addCircleToMap(point, nearest?) {
    if (nearest) {
      var p = H.geo.Point.fromIPoint(nearest);
      var markerDist = p.distance(point);

      const radiusValues = [
        1, 2, 5, 10, 15, 20, 25, 50, 75, 100, 200, 250, 500, 1000,
      ];
      let rad = radiusValues.find((r) => r * 1000 > markerDist);

      if (rad) {
        this.intRadius = rad;
      } else {
        this.intRadius = 1000;
      }
    } else {
      this.intRadius = 1000;
    }

    if (this.radiusCircle == null) {
      this.radiusCircle = new H.map.Circle(point, this.intRadius * 1000, {
        style: {
          strokeColor: "rgba(0, 171, 239, 0.6)",
          lineWidth: 2,
          fillColor: "rgba(0, 171, 239, 0.2)",
        },
      });
      this.map.addObject(this.radiusCircle);
      this.zoomOutMapAfterLocationChanged();
      this.map.setCenter(point);
    } else {
      this.radiusCircle.setRadius(this.intRadius);
      this.zoomOutMapAfterLocationChanged();
      this.map.setCenter(point);
    }
  }

  private startClustering() {
    let noiseIcon = new H.map.Icon(this.konsiSvg, {
      size: { w: 30, h: 40 },
      anchor: { x: 10, y: 10 },
      crossOrigin: false,
    });

    let dataPoints = this.points.map((point) => {
      return new H.clustering.DataPoint(point.lat, point.lng);
    });

    let clusteredDataProvider = new H.clustering.Provider(dataPoints, {
      clusteringOptions: {
        eps: 32,
        minWeight: 2,
      },
      theme: {
        getClusterPresentation: (cluster) => {
          var weight = cluster.getWeight();
          var canvas, textPos;

          if (weight < 10) {
            canvas = this.clusterIcon(this, 28, "51,51,51");
            textPos = { x: 11, y: 18 };
          } else if (weight < 25) {
            canvas = this.clusterIcon(this, 38, "51,51,51");
            textPos = { x: 13, y: 23 };
          } else if (weight < 50) {
            canvas = this.clusterIcon(this, 38, "51,51,51");
            textPos = { x: 13, y: 23 };
          } else if (weight < 100) {
            canvas = this.clusterIcon(this, 38, "51,51,51");
            textPos = { x: 13, y: 23 };
          } else if (weight < 1000) {
            canvas = this.clusterIcon(this, 48, "51,51,51");
            textPos = { x: 15, y: 28 };
          } else {
            canvas = this.clusterIcon(this, 66, "51,51,51");
            textPos = { x: 20, y: 38 };
          }
          var context = canvas.getContext("2d");
          context.fillStyle = "#FFFFFF";
          var fontSize = 11;
          context.font = "bold " + fontSize + "px Arial";
          var testXPos = textPos.x;
          var testYPos = textPos.y;
          context.fillText(weight, testXPos, testYPos);

          var icon = new H.map.Icon(canvas, {
            anchor: {
              x: canvas.width / 2,
              y: canvas.width / 2,
            },
            crossOrigin: false,
          });

          var clusterMarker = new H.map.Marker(cluster.getPosition(), {
            icon: icon,
            min: cluster.getMinZoom(),
            max: cluster.getMaxZoom(),
          });
          clusterMarker.setData(cluster);

          return clusterMarker;
        },
        getNoisePresentation: function (noisePoint) {
          var noiseMarker = new H.map.Marker(noisePoint.getPosition(), {
            icon: noiseIcon,
            min: noisePoint.getMinZoom(),
          });
          noiseMarker.setData(noisePoint);
          return noiseMarker;
        },
      },
    });

    let clusteringLayer = new H.map.layer.ObjectLayer(clusteredDataProvider);

    this.map.addLayer(clusteringLayer);
  }

  private clusterIcon(self, size, color) {
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");

    canvas.width = canvas.height = size;

    var center = size / 2;
    if (context) {
      context.beginPath();
      context.strokeStyle = "rgba(" + color + ",0.2)";
      context.fillStyle = "rgba(" + color + ",1)";
      context.arc(center, center, center, 0, 2 * Math.PI, !1);
      context.fill();
    }

    return canvas;
  }

  private findNearestPoint(point: H.geo.IPoint) {
    var minDist = Number.MAX_VALUE,
      nearest: H.geo.IPoint | null = null;

    // iterate over objects and calculate distance between them
    for (var i = 0; i < this.points.length; i += 1) {
      var p = H.geo.Point.fromIPoint(this.points[i]);
      var markerDist = p.distance(point);
      if (markerDist < minDist) {
        minDist = markerDist;
        nearest = this.points[i];
      }
    }
    return nearest;
  }
  private zoomOutMapAfterLocationChanged() {
    if (this.radiusCircle) {
      switch (true) {
        case this.intRadius == 1000:
          this.map.setZoom(4);
          break;
        case this.intRadius == 500:
          this.map.setZoom(5);
          break;
        case this.intRadius >= 200 && this.intRadius < 500:
          this.map.setZoom(6);
          break;
        case this.intRadius == 100:
          this.map.setZoom(7);
          break;
        case this.intRadius >= 50 && this.intRadius < 100:
          this.map.setZoom(8);
          break;
        case this.intRadius == 25:
          this.map.setZoom(9);
          break;
        case this.intRadius >= 15 && this.intRadius <= 20:
          this.map.setZoom(10);
          break;
        case this.intRadius == 10:
          this.map.setZoom(11);
          break;
        case this.intRadius == 5:
          this.map.setZoom(12);
          break;
        case this.intRadius == 2:
          this.map.setZoom(13);
          break;
        case this.intRadius == 1:
          this.map.setZoom(14);
          break;
      }
      this.$emit("radiusCircleChange", this.intRadius);
    }
  }
}
